"use client";
import React, { ReactNode } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebook,
  faInstagram,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { ContainerGlob } from "./ContainerGlob";
import { useTranslation } from "react-i18next";
import LocaleSwitch from "./LanguageSwitcher";

interface HeaderGlobProps {
  children?: ReactNode;
  className?: string;
  extended?: boolean;
}

const SocialIcon = ({
  href,
  icon,
  label,
}: {
  href: string;
  icon: IconDefinition;
  label: string;
}) => (
  <a
    href={href}
    aria-label={label}
    className="hover:opacity-80 transition-opacity text-lg sm:text-xl text-white"
    target="_blank"
    rel="noopener noreferrer"
  >
    <FontAwesomeIcon icon={icon} />
  </a>
);

export const HeaderGlob: React.FC<HeaderGlobProps> = ({
  children,
  className = "",
  extended = false,
}) => {
  const { t } = useTranslation("common");

  if (children) {
    return <header className={className}>{children}</header>;
  }

  return (
    <header
      className={`w-full content-center text-white ${
        extended ? "py-13" : "0"
      } ${className}`}
      style={{
        background:
          "linear-gradient(90deg, rgb(221, 203, 75) 0%, rgb(237, 113, 73) 30%, rgb(245, 61, 135) 54%, rgb(115, 75, 231) 80%, rgb(65, 147, 249) 100%)",
        fontFamily: "var(--font-manrope)",
      }}
    >
      <ContainerGlob>
        <div className="grid grid-cols-2 sm:grid-cols-3 items-center">
          {/* Icone Social - Colonna sinistra */}
          <div className="flex gap-4 sm:gap-5">
            <SocialIcon
              href="https://www.facebook.com/beehivesud"
              icon={faFacebook}
              label="Facebook"
            />
            <SocialIcon
              href="https://www.instagram.com/beehivesud/"
              icon={faInstagram}
              label="Instagram"
            />
            <SocialIcon
              href="https://www.linkedin.com/company/beehive-valore-sud/posts/?feedView=all"
              icon={faLinkedin}
              label="LinkedIn"
            />
          </div>
          <h1 className="hidden sm:block text-center text-sm sm:text-base font-semibold leading-snug min-w-md max-w-lg mx-auto">
            {t("mission")}
          </h1>
          <div className="flex justify-end">
            <LocaleSwitch />
          </div>
        </div>
      </ContainerGlob>
    </header>
  );
};

export default HeaderGlob;
